import React, { useEffect, useState } from "react";
import { PrimatyAddressPreQualType, SingleBusinessAddressType } from "types";
import {
  trackPageViewUserStep,
  trackSaveAndContinueUserStep,
} from "utils/analytics/trackEvent";
import AddressDropdown from "./components/AddressDropdown";
import PrimaryAddressEditForm from "./components/PrimaryAddressEditForm";
import PrimaryBusinessAddressForm from "./components/PrimaryAddressForm";

interface IPrimaryBusinessAddressProps {
  data: PrimatyAddressPreQualType;
  setNextStep: () => void;
  disableNextStep?: boolean;
}

const PrimaryBusinessAddress = ({
  ...props
}: IPrimaryBusinessAddressProps): JSX.Element => {
  const { data } = props;

  useEffect(() => {
    window.scrollTo(0, 0);
    trackPageViewUserStep(1, "Primary business address", 1);
  }, []);

  const { setNextStep } = props;
  const [isLoadingSteps, setIsLoadingSteps] = useState(false);

  const handleNextClick = () => {
    setIsLoadingSteps(true);
    trackSaveAndContinueUserStep(1, "Primary business address", 1);
    setNextStep();
  };

  const primaryaddress = data?.officeLocations?.filter(
    (address: SingleBusinessAddressType) => address.isHq === true
  );

  const hasPrimaryaddress = data?.officeLocations?.some(
    (address: SingleBusinessAddressType) => address.isHq === true
  );

  const hasAddressOnFile = (data?.officeLocations?.length ?? 0) > 0;

  return (
    <div>
      <div>
        {hasPrimaryaddress && (
          <PrimaryAddressEditForm
            data={primaryaddress?.[0]}
            handleNextClick={handleNextClick}
            disableNextStep={props.disableNextStep || isLoadingSteps}
          />
        )}
        {!hasPrimaryaddress && !hasAddressOnFile && (
          <PrimaryBusinessAddressForm
            data={primaryaddress?.[0]}
            handleNextClick={handleNextClick}
            disableNextStep={props.disableNextStep || isLoadingSteps}
          />
        )}
        {!hasPrimaryaddress && hasAddressOnFile && (
          <AddressDropdown
            data={data}
            handleNextClick={handleNextClick}
            disableNextStep={props.disableNextStep || isLoadingSteps}
          />
        )}
      </div>
    </div>
  );
};
export default PrimaryBusinessAddress;
